import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './styles/index.css'
import { registerServiceWorker } from './utils/registerServiceWorker'
import i18n from './i18n/config' // Initialize i18n
import { detectInitialLanguage } from './utils/ipDetection'
import { loadLoyaltyConfig } from './utils/loyaltySystem'

// Register Service Worker for PWA
registerServiceWorker()

// Load loyalty configuration from database
loadLoyaltyConfig().then(() => {
}).catch(error => {
  console.warn('⚠️ Failed to load loyalty config, using defaults')
})

// Auto-detect and set language based on IP
// Default: Vietnamese (vi)
// If IP is not from Vietnam: Auto-switch to English (en)
detectInitialLanguage().then(language => {
  i18n.changeLanguage(language)
}).catch(error => {
  console.error('⚠️ Language detection error:', error)
  // Fallback to Vietnamese on error
  i18n.changeLanguage('vi')
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
